import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type TAccordion = {
  expandFirst?: boolean;
  data: {
    title: string;
    content: string | React.ReactNode;
    uniqueKey: string;
  }[];
};

const Accordion = ({ data, expandFirst }: TAccordion) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  React.useEffect(() => {
    if (expandFirst) {
      setExpanded(data[0].uniqueKey);
    }
  }, []);

  return (
    <div>
      {data.map((item) => (
        <StyledAccordion
          key={item.uniqueKey}
          expanded={expanded === item.uniqueKey}
          onChange={handleChange(item.uniqueKey)}
          disableGutters
        >
          <MuiAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div style={{ fontSize: "14px" }}>
              <strong>{item.title}</strong>
            </div>
          </MuiAccordionSummary>
          <AccordionDetails>{item.content}</AccordionDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};

export default Accordion;

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  fontFamily: theme.typography.fontFamily,
}));

const StyledAccordion = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: "#222222",
  color: "#f5f5f5",
  fontFamily: theme.typography.fontFamily,

  ".MuiSvgIcon-root": {
    color: theme.shapeTheme === "dark" ? theme.tokens.colors.gray[6] : theme.tokens.colors.gray[5],
  },
  "&:before": {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
  },
  "&.Mui-expanded": {
    "&:before": {
      opacity: 1,
    },
  },
}));
